import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import styles from './creation_menu_content.scss'

import betaLabel from 'assets/images/beta-label.svg'

const CreationMenuContent = props => (
	<div styleName='wrapper'>
		<p styleName='text'>
			<span styleName='text-title'>
				{props.title}

				{ props.isBeta &&
					<Isvg
						styleName='text-beta-label'
						src={betaLabel}
						cacheGetRequests={true}
					/>
				}
			</span>
			<span styleName='text-description'>{props.description}</span>
		</p>
	</div>
)

CreationMenuContent.propTypes = {
	title: PropTypes.string,
	isBeta: PropTypes.bool,
	description: PropTypes.string,
}

CreationMenuContent.defaultProps = {
	title: '',
	isBeta: false,
	description: '',
}

export default CSSModules(CreationMenuContent, styles, {allowMultiple: true})
